module.exports = __webpack_public_path__ + "img/img_personal@2x.6de38498.png";